import 'regenerator-runtime';
import './services/axios-config';

// Needed for randombytes in react-oidc
window.global ||= window;

console.log(`Initializing ERP Service UI ${import.meta.env.VITE_APP_VERSION}`);
